import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from '@/lib/constants/routes';
import { ROLES } from '@/lib/constants/app.constants';
import { normalizeAppReturnPath, POST_LOGIN_REDIRECT_STORAGE_KEY } from '@/lib/auth/post-login-redirect';
import { useLayoutEffect } from 'react';

export const ProtectedRoute = () => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

   useLayoutEffect(() => {
    if (isAuthenticated) {
      return;
    }
    const returnPath = `${location.pathname}${location.search}`;
    if (returnPath !== ROUTES.LOGIN) {
      sessionStorage.setItem(POST_LOGIN_REDIRECT_STORAGE_KEY, normalizeAppReturnPath(returnPath));
    }
  }, [isAuthenticated, location.pathname, location.search]);
 

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  // Check if user has planner or system admin role
  const hasAuthorizedRole = (): boolean => {
    if (!user || !user.roles || user.roles.length === 0) {
      return false;
    }
    return user.roles.includes(ROLES.PLANNER) || user.roles.includes(ROLES.SYSTEM_ADMIN);
  };

  if (!hasAuthorizedRole()) {
    return <Navigate to={ROUTES.UNAUTHORIZED} replace />;
  }

  return <Outlet />;
};

